import { PlatformTransactionTypeDto } from 'api/Trading-Accounts/Types/PlatformTransactionTypeDto'

export const getAllowedTransactionTypes = (
  platformTransactionTypes: PlatformTransactionTypeDto[]
): PlatformTransactionTypeDto[] => {
  const allowedTransactionTypes = ['Buy', 'Sell', 'Balance']
  return platformTransactionTypes.filter((x) => allowedTransactionTypes.find((y) => x.name === y))
}
